import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../../trip-view/services/common.service';
import { CommonCabService } from '../../services/common-cab.service';
import { CommonService as TripReplayCommonService } from '../../../trip-replay/services/common.service';
import { catchError, concatMap, of } from 'rxjs';
import { DateUtils } from 'src/app/utils/days-utils';
@Component({
  selector: 'app-trip-view-cab',
  templateUrl: './trip-view-cab.component.html',
  styleUrls: ['./trip-view-cab.component.scss']
})
export class TripViewCabComponent implements OnInit {
  tripStatus: any = "";
  adhoc_text: any;
  cardDataLoaded: boolean;
  constructor(private commonService: CommonService, private commonCabService: CommonCabService,private tripReplayCommonService:TripReplayCommonService) { }
  cabResponse: any;
  loader = true;
  timeZone = 'Asia/Kolkata';
  attendance: any =
    {
      adhocCount: 0,
      noShowCount: 0,
      totalPlannedEmployeesToBoard: 0,
      plannedemployeesBoarded: 0,
      totalCapacity: 0
    }
  ngOnInit(): void {
    this.commonService.getTimeZone().subscribe((res)=>{

      this.commonService.timeZone=res['timeZone'];
      this.commonCabService.timeZone = res['timeZone']
      this.tripReplayCommonService.timeZone = res['timeZone']
      this.timeZone=res['timeZone'];
      this.getSideViewDataCab()
    })

    setInterval(() => {
      this.getSideViewDataCab();
    }, 60000);
  }


  //implementing Socket Cluster in the code 






  getSideViewDataCab() {
    this.commonCabService.getTripDetails(this.commonCabService.tripId).
    pipe(
      concatMap((res:any) => {
        this.tripStatus = res.tripDetails.status;
        this.adhoc_text = res.tripDetails?.adhocConversionAudit?.fieldchange || '';
        this.commonCabService.response = res
        this.cabResponse = res;
        this.loader = false;
        res['tripDetails'].shuttleStops = [];
  
        res['tripDetails'].employees = res['tripDetails'].employees.filter((emp) => emp.empStatus !== 'STATUS_CANCELLED_FROM_DASHBOARD');
  
        const allEmployees: any = res['tripDetails'].employees.map((obj: {
          name: any,
          employeeId: any,
          gender: any,
          plannedPickupLocation: any,
          plannedPickupTime: any,
          plannedDropTime: any,
          distanceTravelled: any,
          fdTravelledDistance?: any,
          phoneNumber: any,
          driverReportingTime: any,
          noShow: any,
          adhoc: any,
          actualPickupTime: any,
          actualDropTime: any,
          actualPickupLocation: any,
          userType: any,
          empTripStatus: any,
          geocord: any,
          projectName:any,
          plannedEndTime: any,
          actualEndTime: any,
          plannedDropLocation: any,
          actualDropLocation: any,
          escort?: boolean,
          signedOff?: boolean,
          cabIn?: any,
          cabOut?: any,
          proximityHitIn?: any,
          proximityHitOut?: any,
          specialNeedType?: any,
          noShowMarkedBy?: any,
          noShowTimeStamp?: any
        }, index: number) => ({
          serialNumber: index + 1,
          name: obj.name,
          Id: obj.employeeId,
          plannedPickUp: obj.plannedPickupLocation?.address,
          actualPickUp: obj.actualPickupLocation?.address,
          plannedDrop: obj.plannedDropLocation?.address,
          actualDrop: obj.actualDropLocation?.address,
      
          signIn: DateUtils.formatTimeWithZone(obj.actualPickupTime, this.timeZone),
          signOut: DateUtils.formatTimeWithZone(obj.actualDropTime, this.timeZone),
          plannedSignOut: DateUtils.formatTimeWithZone(obj.plannedDropTime, this.timeZone),
          plannedSignIn: DateUtils.formatTimeWithZone(obj.plannedPickupTime, this.timeZone),
          driverReportingTime: obj.driverReportingTime,
          reportingTimeDriver: DateUtils.formatTimeWithZone(obj.driverReportingTime, this.timeZone),

          isMArshal: obj.userType === 'ESCORT' ? true : false,
          reportTime: obj.driverReportingTime,
          distance: obj.distanceTravelled,
          fdTravelledDistance: obj?.fdTravelledDistance,
          gender: obj.gender,
          adhoc: obj.adhoc,
          noShow: obj.noShow,
          phone: obj.phoneNumber,
          projectName:obj.projectName,
          empTripStatus: obj.empTripStatus,
          geocord: !!obj.actualPickupLocation?.geocord ? obj.actualPickupLocation.geocord : obj.plannedPickupLocation.geocord,
          plannedPickupTime: DateUtils.formatTimeWithZone(obj.plannedPickupTime, this.timeZone),
          actualPickupTime: obj.actualPickupTime,
          plannedPickUpLocation: obj.plannedPickupLocation,
          actualPickUpLocation: obj.actualPickupLocation,
          cabIn:DateUtils.formatTimeWithZone(obj?.cabIn, this.timeZone),
          cabOut:DateUtils.formatTimeWithZone(obj?.cabOut, this.timeZone),
          proximityHitIn:DateUtils.formatTimeWithZone(obj?.proximityHitIn, this.timeZone),
          proximityHitOut:DateUtils.formatTimeWithZone(obj?.proximityHitOut, this.timeZone),
  
          plannedDropTimestamp: obj.plannedDropTime,
          plannedPickupTimestamp: obj.plannedPickupTime,
  
          plannedEndTime: DateUtils.formatTime(obj.plannedDropTime),
          actualEndTime: DateUtils.formatTime(obj.actualEndTime),          
          actualDropTime: obj.actualDropTime,
          plannedDropLocation: obj.plannedDropLocation,
          actualDropLocation: obj.actualDropLocation,
          escort: obj.escort,
          signedOff: obj.signedOff,
          specialNeedType: obj.specialNeedType,
          noShowMarkedBy: obj?.noShowMarkedBy || null,
          noShowTimeStamp: obj?.noShowTimeStamp || null
  
        }));
        this.commonCabService.employeeDetails$.next(allEmployees);
        let timestampAddressMap = {};
        allEmployees.forEach((emp) => {
          if (res['tripDetails'].direction === 'OUT') {
            timestampAddressMap[emp.plannedPickupTimestamp] = emp.plannedPickUp;
          } else {
            timestampAddressMap[emp.plannedDropTimestamp] = emp.plannedDrop;
          }
        })
        const sortedPairs = Object.entries(timestampAddressMap).sort(([keyA], [keyB]) => Number(keyA) - Number(keyB));
        const entries = Object.entries(sortedPairs);
        let loginLogoutStopsSeq = [];
        for (const [key, value] of entries) {
          loginLogoutStopsSeq.push(value[1]);
        }
        loginLogoutStopsSeq = loginLogoutStopsSeq.filter(function (element) {
          return element !== undefined;
        });
        this.commonCabService.loginLogoutStops$.next(loginLogoutStopsSeq);
        console.log('loginLogout', loginLogoutStopsSeq);
  
  
        let adhocCount = 0;
        let noShowCount = 0;
        let totalPlannedEmployeesToBoard = 0;
        let plannedemployeesBoarded = 0;
  
        for (let i = 0; i < allEmployees.length; i++) {
          if (allEmployees[i].adhoc === true) {
            adhocCount++;
          }
          if (allEmployees[i].noShow === true && allEmployees[i].plannedPickupLocation !== null) {
            noShowCount++;
          }
          if (allEmployees[i].adhoc == false && allEmployees[i].noShow == false && (allEmployees[i].actualPickupTime === 0 || allEmployees[i].actualPickupTime === null)) {
            totalPlannedEmployeesToBoard++;
          }
          if ((allEmployees[i].actualPickupTime !==null && allEmployees[i].actualPickupTime!==0) && allEmployees[i].adhoc === false && allEmployees[i].noShow == false) {
            plannedemployeesBoarded++;
          }
        }
        this.attendance.adhocCount = adhocCount
        this.attendance.noShowCount = noShowCount
        this.attendance.totalPlannedEmployeesToBoard = totalPlannedEmployeesToBoard;
        this.attendance.plannedemployeesBoarded = plannedemployeesBoarded
        this.attendance.totalCapacity = res['tripDetails'].vehicle?.vehicleType?.maxCapacity
        this.commonCabService.attendance$.next(this.attendance)
  
        const employeesByActualLocalityId = res['tripDetails'].employees.reduce((acc: any, emp: any) => {
          console.log("Actual loaction 1", acc);
          if (emp.actualPickupLocation != undefined) {
            const actualLocalityId = emp.actualPickupLocation.locationId;
            const plannedLocalityId = emp.plannedPickupLocation?.locationId;
            const localityId = emp.actualPickupLocation?.locationId;
            console.log("Actual loaction 2", acc);
  
            if (actualLocalityId !== plannedLocalityId) {
              if (acc[localityId] === undefined) {
                acc[localityId] = [];
              }
              acc[localityId].push(emp);
            }
          }
          return acc;
  
        }, {});
  
        const employeesByPlannedLocality = res['tripDetails'].employees.reduce((acc: any, emp: any) => {
          const localityId = emp.plannedPickupLocation?.locationId;
          if (acc[localityId] === undefined) {
            acc[localityId] = [];
          }
          acc[localityId].push(emp);
          return acc;
        }, {});
  
  
  
  
        const shuttleStopsWithEmployees = res['tripDetails'].shuttleStops.map((stop: any, index: number) => {
  
          const employeesForStop = employeesByPlannedLocality[stop.nativeId] ?? [];
          const employeesByActualLocality = employeesByActualLocalityId[stop.nativeId] ?? [];
  
          let employeeForPlannedStop = [];
          allEmployees.forEach((emp) => {
            if (!!emp.plannedPickUp && emp.plannedPickUp === stop.address) {
              employeeForPlannedStop.push(emp);
              return;
            } else if (!!emp.actualPickUp && emp.actualPickUp === stop.address && !emp.plannedPickUp) {
              employeeForPlannedStop.push(emp);
            }
          })
          console.log('employeePlannedStops', employeeForPlannedStop, stop.address);
  
  
          // console.log("ALL Emp Planned to Stop ",employeesByPlannedLocality,employeesForStop);
  
          const simplifiedEmployees = employeeForPlannedStop.map((emp: any) => ({
            employeeId: emp.Id,
            stwId: emp.stwId,
            name: emp?.name,
            actualPickupTime: emp.actualPickupTime,
            actualDropTime: emp.actualDropTime,
            gender: emp.gender,
            localityId: emp.plannedPickupLocation?.locationId,
            isPicked: (emp.actualPickupTime != 0 ? true : false),
            plannedPickupTime: emp.plannedPickupTime,
            plannedDropTime: emp.plannedDropTime,
            noShow: emp.noShow,
            plannedPickUpLocation: emp.plannedPickupLocation?.address,
            plannedDropLocation: emp.plannedDropLocation?.address,
            StopActualArrivalTime: stop.actualArrivalTime,
            signIn: emp.signIn,
            signOut: emp.signOut,
            plannedSignIn: emp.plannedSignIn,
            adhoc: emp.adhoc,
            plannedLocalityId: emp.plannedPickupLocation?.locationId,
            actualLocalityId: emp.actualPickupLocation?.locationId, // null check
            empStatus: emp.empStatus,
            phoneNumber: emp.phoneNumber,
            geocord: emp.geocord,
            reportingDriverTime: emp.reportingTimeDriver,
            driverReportingTime: emp.driverReportingTime
          }));
          console.log("employee for debugging", simplifiedEmployees);
  
          const numberOfEmployeestoBoard = simplifiedEmployees.filter((emp: any) => emp.adhoc === false).length;
          const numberOfPickedEmployees = simplifiedEmployees.filter((emp: any) => emp.isPicked).length;
          const totalNumberOfNoShowEmployees = simplifiedEmployees.filter((emp: any) => emp.noShow).length;
          // const unPlannedEmployeesOnStopStatus = simplifiedEmployees.filter((emp: any) => emp.actualLocalityId === stop.localityId && (emp.empStatus === 'Adhoc' || emp.empStatus === 'unplanned'));
  
          let adhocEmployees = [];
          allEmployees.forEach(emp => {
            console.log('emp adjhocv', emp, stop);
  
            if (emp.adhoc === true && emp.actualPickupLocation?.locationId === stop.nativeId) {
              adhocEmployees.push(emp);
            }
          })
  
          return {
            ...stop,
            index: index + 1,
            employees: simplifiedEmployees,
            numberOfEmployeestoBoard: numberOfEmployeestoBoard,
            numberOfEmployeesBoarded: numberOfPickedEmployees,
            totalNumberOfNoShowEmployees: totalNumberOfNoShowEmployees,
            formattedPlannedArrivalTime: DateUtils.formatTime(stop.plannedArrivalTime),
            formattedActualArrivalTime: DateUtils.formatTime(stop.actualArrivalTime),
            unPlannedEmployeesOnStop: employeesByActualLocality,
            adhocEmployees: adhocEmployees
          };
        });
  
        // this.commonCabService.busStopsDetails$.next(shuttleStopsWithEmployees)
        console.log("shutlle stops", shuttleStopsWithEmployees);
        if (this.tripStatus !== "") {
          this.commonCabService.getDriverActions(res['tripDetails'].tripUuid, this.commonCabService.tripId).subscribe((res: any) => {
            this.commonCabService.driverActions$.next(res)
          })
        }
      // return this.commonCabService.getTicketDetails()
      return this.commonCabService.getTicketDetails()
      .pipe(
        catchError((error) => {
          console.error('Error fetching ticket details:', error);
          // Returning an empty observable so the next steps continue
          return of([]);
        })
      );
    }
      
    )).subscribe((res:any) => {
      let ticketArray = []
      let ticketDetails = res?.data
      try{
      for(let item of ticketDetails){
         const obj =  {
            ticketType:item["ticketType"].replace('_',' '),
            ticketId:item["ticketId"],
            ticketUrl:item['URL']
          }
          ticketArray.push(obj)
      }
      }catch(e){
      ticketArray = []
      }
      this.commonCabService.ticketDetails = ticketArray
      this.cardDataLoaded = true;
    })
    



  }




}
